// src/utils/toast.js
export function toast({ title, description = '', variant = 'default', duration = 4000 }) {
    const existing = document.getElementById('simple-toast');
    if (existing) existing.remove();
  
    const container = document.createElement('div');
    container.id = 'simple-toast';
    container.style.position = 'fixed';
    container.style.bottom = '2rem';
    container.style.right = '2rem';
    container.style.padding = '1rem 1.5rem';
    container.style.borderRadius = '8px';
    container.style.color = 'white';
    container.style.backgroundColor =
      variant === 'success'
        ? '#22c55e'
        : variant === 'destructive'
        ? '#ef4444'
        : '#3b82f6';
    container.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.1)';
    container.style.zIndex = '9999';
    container.style.fontSize = '14px';
    container.style.maxWidth = '300px';
    container.innerHTML = `
      <strong style="display:block;margin-bottom:4px;">${title}</strong>
      <span>${description}</span>
    `;
  
    document.body.appendChild(container);
  
    setTimeout(() => {
      container.remove();
    }, duration);
  }
  